// Copyright (c) 2017 Deere & Company

import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import t from 'tcomb';

const RegistrationDomainValues = t.struct({
    endUseCodes: KeyValuePairCollection,
    otherUseUnits: KeyValuePairCollection,
    purchaseTypes: KeyValuePairCollection,
    registrationTypes: KeyValuePairCollection
}, 'RegistrationDomainValues');

export const getDefaultState = () =>
    new RegistrationDomainValues({
        endUseCodes: getDefaultKeyValueCollection(),
        otherUseUnits: getDefaultKeyValueCollection(),
        purchaseTypes: getDefaultKeyValueCollection(),
        registrationTypes: getDefaultKeyValueCollection()
    });

export default RegistrationDomainValues;



// WEBPACK FOOTER //
// ./src/product/product-registration/state/registration-domain-values.js